import { get } from 'lodash';

export const getWorkspaceName = (state) => get(state, 'bookings.widget.bookteq_workspace_name');
export const getWidgetId = (state) => get(state, 'bookings.widget.bookteq_widget_id');
export const getWidgetDomain = (state) => get(state, 'bookings.apiUrl');
export const getWidgetEnabled = (state) => get(state, 'bookings.widget.is_enabled');
export const getWidgetScriptUrl = (state) => get(state, 'bookings.scriptUrl');
